import React, { useEffect, useState } from "react";
import Container from "../../Container";
import Heading from "../../../Components/Heading/Heading";
import { Link } from "react-router-dom";
import { message } from "antd";
import CategoryCards from "../CategoryCards/CategoryCards";

const MainCategories = ({ Category }) => {
    const [data, setData] = useState([]);
    const [SkeletonLoad, setSkeletonLoad] = useState(true);
    const skeletonArray = Array.from({ length: 8 }, (_, index) => index);
    const [messageApi, contextHolder] = message.useMessage();

    const getAllCategory = () => {
        setSkeletonLoad(true);
        var requestOptions = {
            method: "GET",
            redirect: "follow",
        };

        fetch(
            process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "admin/getHomeZoneAppliances",
            // "/admin/getHomeZoneAppliances",
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => {
                // console.log('result',result);
                if (result.status === 200) {
                    setData(result.data);
                    setSkeletonLoad(false);
                }
            })
            .catch((error) => console.log("error", error));
    };

    useEffect(() => {
        getAllCategory();
    }, []);

    return (
        <div className="my-10">
            <div className="my-10">
                <h1 className="text-xl md:text-2xl text-center text-gray-800 tracking-wider">
                    Step Inside a World of Home Interiors{" "}
                    <span className="text-xl md:text-2xl font-extrabold text-[#027100]">
                        Browse by Categories
                    </span>
                </h1>
                <CategoryCards
                    linkTo="/sub-category"
                    data={data}
                    SkeletonLoad={SkeletonLoad}
                    skeletonArray={skeletonArray}
                    className="grid grid-cols-3 md:grid-cols-5 xl:grid-cols-8 gap-x-[10px] md:gap-x-[50px] gap-y-1 md:gap-y-4 cursor-pointer"
                />
            </div>
        </div>
    );
};

export default MainCategories;
